import { Component, forwardRef } from "react";
import Header from "../../../common_components/Header.js";
import Loader from "../../../utils/Loader.js";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination.js";
import { withRouter } from "../../../utils/withRouter.js";
import { connect } from "react-redux";
import {
  receipt_list_search_action,
  shareEmail_action,
  getEmailData_action,
  getReceiptPdf_action,
  receiptShare_action,
} from "../../../actions/admin_module_action/registration_receipt_actions/receipt_action.js";
import {
  get_refund_type_amount_action,
  generate_refund_voucher_action,
  refund_update_action,
  refundShare_action,
  add_refund_action,
  delete_refund_action,
  get_receipt_list_action,
  getRefunedPdf_action,
} from "../../../actions/admin_module_action/refund_action/refund_action.js";
import {
  downloadReport,
  toastError,
  toastSuccess,
} from "../../../utils/constants.js";
import AdminHeader from "../../../common_components/admin_module_header.js";
import AdminDrawer from "../../../common_components/admin_module_drawer.js";
import Workbook from "react-excel-workbook";
import Modal from "react-modal";
import Footerwithdr from "../../../common_components/Footerwithdr.js";
import HeaderWithLogo from "../../../common_components/header_with_logo.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header.js";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer.js";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu.js";
import { fill_action } from "../../../actions/fillCombo_action.js";
import WorkUpdation from "../../hallManager_module/work_updation.js";
import VendorView from "./vendorView/vendorView.js";
import HallView from "./hallView/hallView.js";
import LayoutView from "./layoutView/layoutView.js";
import GraphView from "./graphView/graphView.js";
import VendorTaskDetail from "../../vendor_module/vendor_task/vendor_task_detail.js";
import VendorStaticList from "../../vendor_module/vendor_static_list/vendor_static_list.js";

const styles = {
  width: "100%",
};

class OrganizerTrackerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      sectionPage: "VendorView",
    };
  }

  componentDidMount() { }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { isLoading, sectionPage } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <>
          <div className="app-content with-dr-container com-height">
            <div className="navg mt-0">
              <ul className="nav nav-pills with-dr-container tab-scroll-fixed">
                <li onClick={() => this.setState({ sectionPage: "VendorView" })} className="nav-item">
                  <a className={sectionPage == "VendorView" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Service Partner View
                  </a>
                </li>
                <li onClick={() => this.setState({ sectionPage: "HallView" })} className="nav-item">
                  <a className={sectionPage == "HallView" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Hall View
                  </a>
                </li>
                <li onClick={() => this.setState({ sectionPage: "LayoutView" })} className="nav-item">
                  <a className={sectionPage == "LayoutView" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Layout View
                  </a>
                </li>
                <li onClick={() => this.setState({ sectionPage: "GridView" })} className="nav-item">
                  <a className={sectionPage == "GridView" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Grid View
                  </a>
                </li>
                <li onClick={() => this.setState({ sectionPage: "GraphView" })} className="nav-item">
                  <a className={sectionPage == "GraphView" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Graph View
                  </a>
                </li>
                <li onClick={() => this.setState({ sectionPage: "VendorTask" })} className="nav-item">
                  <a className={sectionPage == "VendorTask" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Service Partner Task
                  </a>
                </li>
                <li onClick={() => this.setState({ sectionPage: "VendorStaticList" })} className="nav-item">
                  <a className={sectionPage == "VendorStaticList" ? "nav-link active px-4 py-2" : "nav-link px-3 py-2"}>
                    Service Partner List
                  </a>
                </li>
              </ul>
            </div>
            {sectionPage == "VendorView" && <VendorView />}
            {sectionPage == "HallView" && <HallView />}
            {sectionPage == "LayoutView" && <LayoutView />}
            {sectionPage == "GridView" && <WorkUpdation />}
            {sectionPage == "GraphView" && <GraphView />}
            {sectionPage == "VendorTask" && <VendorTaskDetail />}
            {sectionPage == "VendorStaticList" && <VendorStaticList />}
          </div>
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorDrawer />
          ) : (
            <AdminDrawer />
          )}
        </>
        <Footerwithdr />
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
  })(OrganizerTrackerList)
);
